import { render, staticRenderFns } from "./ChangeHistoryLegal.vue?vue&type=template&id=3d50018d&scoped=true"
import script from "./ChangeHistoryLegal.vue?vue&type=script&lang=js"
export * from "./ChangeHistoryLegal.vue?vue&type=script&lang=js"
import style0 from "./ChangeHistoryLegal.vue?vue&type=style&index=0&id=3d50018d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d50018d",
  null
  
)

export default component.exports